
  <nav aria-label="breadcrumb" >
    <ol class=" d-flex  breadcrumb BreadCrumb-bg p-1"  >
    <li
      class="breadcrumb-item breadcrum-color BreadCrumb-text"
      *ngFor="let item of Breadcrumblist; let last = last"
      [ngClass]="{'active': last}"
      [attr.aria-current]="last ? 'page' : null"
    >
      <span *ngIf="last" class="path-class">{{item.Subject_Name}}</span>
      <span *ngIf="!last">{{item.Subject_Name}}</span>
    </li>

        <li class="px-0 pr-1 breadcrumb-item breadcrum-color Breadcrumb-text BreadCrumb-bg red-txt" *ngIf="ReorderTopic !== ''">[{{ReorderTopic}}]</li>
        <li class="px-0 pr-1 breadcrumb-item breadcrum-color Breadcrumb-text BreadCrumb-bg" *ngIf="Breadcrumb !== ''&&!File_Name">{{Breadcrumb}}</li>
        <li class="px-0 pr-1 breadcrumb-item breadcrum-color Breadcrumb-text BreadCrumb-bg" *ngIf="Breadcrumb !== ''&&File_Name !== ''">{{Breadcrumb}} ({{File_Name}})</li>
        <li class="px-0 pr-1 breadcrumb-item breadcrum-color Breadcrumb-text BreadCrumb-bg" *ngIf="Breadcrumb1 !== ''&&File_Name1 !== ''">{{Breadcrumb1}} > Study Material Name : {{File_Name1}}</li>
      </ol>
    </nav>



